import React from 'react'

interface SectionProps {
    id: string
    children: React.ReactNode
    className?: string
    background?: 'light' | 'dark' | 'primary' | 'gradient'
}

const backgroundStyles = {
    light: 'bg-white',
    dark: 'bg-dpxp-dark text-white',
    primary: 'bg-dpxp-primary text-white',
    gradient: 'bg-gradient-to-br from-dpxp-primary to-dpxp-secondary text-white',
}

export function Section({
    id,
    children,
    className = '',
    background = 'light'
}: SectionProps) {
    return (
        <section
            id={id}
            className={`section-padding ${backgroundStyles[background]} ${className}`}
        >
            <div className="container-section">
                {children}
            </div>
        </section>
    )
}
